import script from "./DocumentsFavorite.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsFavorite.vue?vue&type=script&setup=true&lang=js"

import "./DocumentsFavorite.vue?vue&type=style&index=0&id=1daedcfa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1daedcfa"]])

export default __exports__